import t9n from "@bimproject/t9n";
import { Suspense, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import { useDialog } from "~/src/modules/ui-kit";

import orderingFunctions from "./sort";
import * as S from "./styled";
import { useBIMClasses } from "../../../../../../modules/shared-entities";
import * as UI from "../../../../../../modules/ui-kit";
import SearchBait from "../../../components/SearchBait";
import Selection from "../../../components/Selection";


export default function BIMClassesFilter(props) {
    const { disabled, discovery, onChange, value } = props;

    const [Dialog, open] = useDialog();

    const bimClasses = useBIMClasses();

    if (!bimClasses.data) return "loading";

    return (
        <S.Filter>
            <span>BIMClasses</span>
            <Suspense>
                <Selection
                    disabled={ disabled }
                    items={
                        value
                            .map(
                                (bimClassID) => bimClasses.data.bimClasses.find(
                                    (bimClass) => bimClass.id === bimClassID
                                )
                            )
                            .map(
                                (bimClass) => (
                                    {
                                        ...bimClass,
                                        name: t9n(bimClass.data.name, "en"),
                                    }
                                )
                            )
                            .sort(orderingFunctions.az)
                    }
                    onChange={ onChange }
                />
            </Suspense>
            {
                !disabled && (
                    <S.Button onClick={ open } type="button">[select BIMClasses]</S.Button>
                )
            }
            <S.Dialog as={ Dialog }>
                <BIMClassSelection
                    discovery={ discovery }
                    onChange={ onChange }
                    value={ value }
                />
            </S.Dialog>
        </S.Filter>
    );
}

function BIMClassSelection(props) {
    const { children, discovery, onChange, value } = props;

    const bimClasses = useBIMClasses();

    const [ordering, setOrdering] = useState("az");
    const [token, setToken] = useState("");

    if (!discovery) return "loading";
    if (!bimClasses.data) return "loading";

    function toggle(bimClassID) {
        onChange(
            (bimClassIDs) => bimClassIDs.includes(bimClassID)
                ? bimClassIDs.filter(
                    (x) => x !== bimClassID
                )
                : [...bimClassIDs, bimClassID]
        );
    }

    const items = bimClasses
        .data
        .bimClasses
        .map(
            (bimClass) => (
                {
                    ...bimClass,
                    name: t9n(bimClass.data.name, "en"),
                    count: discovery
                        .find(
                            (bimClassScan) => bimClassScan.bimClass.id === bimClass.id.replaceAll("-", "")
                        )
                        ?.count ?? 0,
                }
            )
        )
        .filter(
            (bimClass) => bimClass.name.toLowerCase().includes(token.toLowerCase()) || bimClass.id.replaceAll("-", "") === token.replaceAll("-", "")
        )
        .sort(orderingFunctions[ordering]);

    const filteredSelected = items.filter((bimClass) => value.includes(bimClass.id));
    const filteredOther = items.filter((bimClass) => !value.includes(bimClass.id));

    function bimClassRow(bimClass) {
        return (
            <tr
                key={ bimClass.id }
                onClick={ () => toggle(bimClass.id) }
            >
                <td>{ bimClass.name }</td>
                <td>{ bimClass.count }</td>
            </tr>
        );
    }

    return (
        <S.Selection>
            <SearchBait>
                <div>
                    <input
                        onChange={ (event) => setToken(event.target.value) }
                        placeholder="Search"
                        type="text"
                        value={ token }
                    />
                    {
                        token && (
                            <button
                                onClick={ () => setToken("") }
                                type="reset"
                            >
                                <IoClose />
                            </button>
                        )
                    }
                </div>
            </SearchBait>
            <S.Table
                $hideHeaders={ filteredSelected.length === 0 || filteredOther.length === 0 }
            >
                <thead>
                    <tr>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "az" ? "za" : "az") }>
                                Name
                                <UI.OrderIcon order={ { az: "ASC", za: "DESC" }[ordering] } />
                            </button>
                        </th>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "90" ? "09" : "90") }>
                                # of products
                                <UI.OrderIcon order={ { "09": "ASC", 90: "DESC" }[ordering] } />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Selected
                            <span>({ filteredSelected.length })</span>
                        </th>
                    </tr>
                    { filteredSelected.map(bimClassRow) }
                </tbody>
                <tbody>
                    <tr>
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Other
                            <span>({ filteredOther.length })</span>
                        </th>
                    </tr>
                    { filteredOther.map(bimClassRow) }
                </tbody>
            </S.Table>
            { children }
        </S.Selection>
    );
}
